<app-header *ngIf="!isLoginPage" (toggleSidebar)="expandBtn()"></app-header>

<div class="main-layout" [ngClass]="{ 'login-layout': isLoginPage }">

  <aside class="sidebar" *ngIf="!isLoginPage">
    <app-sidebar [expanded]="expanded"></app-sidebar>
  </aside>
  <div class="home-layout" [ngClass]="{ 'collapsed': !expanded, 'full-width': isLoginPage }">
    <router-outlet></router-outlet>
  </div>
  <app-notifications></app-notifications>
  <div class="loader-overlay" *ngIf="isLoading">
    <div class="loader-content">
      <div class="loader"></div>
      <div class="loader-text">Loading...</div>
    </div>
  </div>
</div>